import axios from "axios";

class RestApi
{
    private readonly _apiHostSelectorPromise: Promise<(endpoint: string) => string>;

    constructor()
    {
        this._apiHostSelectorPromise = this.getApiHostAsync();
    }

    public async getUrl(path: string): Promise<string>
    {
        if (!path)
        {
            path = "/";
        }
        if (path[0] !== "/")
        {
            path = "/" + path;
        }

        const apiHostSelector = await this._apiHostSelectorPromise;
        const baseUrl = apiHostSelector(path);

        return baseUrl + path;
    }

    private cleanHost(host: string): string
    {
        if (!host)
        {
            return "http://localhost:8000";
        }

        if (!host.startsWith("http"))
        {
            if (!host.startsWith("/"))
            {
                host = "//" + host;
            }
        }

        while (host.endsWith("/"))
        {
            host = host.substring(0, host.length - 1);
        }

        return host;
    }

    private async getApiHostAsync(): Promise<(endpoint: string) => string>
    {
        const gskApiHost = process.env.GSK_API_HOST;
        if (gskApiHost)
        {
            console.debug(`GSK_API_HOST env var specified as ${gskApiHost}.`);
            const apiHost = gskApiHost;
            return () => this.cleanHost(apiHost);
        }
        else
        {
            let apiHostJsonUrl = "/api-host.json";

            const gskApiHostSource = process.env.GSK_API_HOST_SOURCE;
            if (gskApiHostSource)
            {
                console.debug(`GSK_API_HOST_SOURCE env var specified as ${gskApiHostSource}.`);
                apiHostJsonUrl = gskApiHostSource;
            }

            console.debug(`Loading ${apiHostJsonUrl}...`);
            const apiHostJson = await axios.get(apiHostJsonUrl);
            console.debug(`Contents of ${apiHostJsonUrl}: ${JSON.stringify(apiHostJson.data)}`);

            const apiHost = this.cleanHost(apiHostJson.data.host);
            const endpoints = apiHostJson.data.endpoints || {};

            return (path: string) =>
            {
                for (const endpoint in endpoints)
                {
                    if (path.match(endpoint))
                    {
                        return this.cleanHost(endpoints[endpoint]);
                    }
                }
                return apiHost;
            };
        }
    }
}

export default new RestApi();
